import { EnvironmentProviders } from '@angular/core';
import {
  ApiOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  LockOutline,
  UserOutline,
  MailOutline,
  SafetyCertificateOutline,
  AlertOutline,
  CloudServerOutline,
  InfoCircleTwoTone,
  RedoOutline,
  LinkOutline,
  ExportOutline,
  DownOutline,
  ApartmentOutline,
  PieChartOutline,
  SwapOutline,
  TranslationOutline,
  WarningOutline,
  GlobalOutline,
  LogoutOutline,
  ThunderboltOutline,
  TeamOutline,
  EditOutline,
  ClockCircleOutline,
  DeleteOutline,
  KeyOutline,
  LaptopOutline,
  PlusOutline,
  SearchOutline,
  StopOutline,
} from '@ant-design/icons-angular/icons';
import { provideNzIcons as provideNzIconsFromNgZorro } from 'ng-zorro-antd/icon';

const icons = [
  ApiOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  LockOutline,
  UserOutline,
  MailOutline,
  SafetyCertificateOutline,
  AlertOutline,
  CloudServerOutline,
  InfoCircleTwoTone,
  RedoOutline,
  LinkOutline,
  ExportOutline,
  DownOutline,
  ApartmentOutline,
  PieChartOutline,
  SwapOutline,
  TranslationOutline,
  WarningOutline,
  GlobalOutline,
  LogoutOutline,
  ThunderboltOutline,
  TeamOutline,
  EditOutline,
  ClockCircleOutline,
  DeleteOutline,
  KeyOutline,
  LaptopOutline,
  PlusOutline,
  SearchOutline,
  StopOutline,
];

export function provideNzIcons(): EnvironmentProviders {
  return provideNzIconsFromNgZorro(icons);
}
